import { render } from "./information.vue?vue&type=template&id=438c94c8&scoped=true"
import script from "./information.vue?vue&type=script&lang=js"
export * from "./information.vue?vue&type=script&lang=js"

import "./information.vue?vue&type=style&index=0&id=438c94c8&lang=css"
import "./information.vue?vue&type=style&index=1&id=438c94c8&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438c94c8"]])

export default __exports__